import list from './list';
import detail from './detail';

export default {
  list,
  detail
};
